import { IReportReq } from "../interfaces/report";
import { get } from "./api";
import { APIUrl } from "../config/api-url.config";
import { IReportDTO } from "../interfaces/dto/report.dto";

export const getTrackier = (payload: IReportReq, token: string, userId: string) =>
  get<IReportReq, IReportDTO>(
    APIUrl.campaignsReport,
    {...payload, userId},
    token,
  );
